import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loading, EmptyState } from "@/components/States";
import { api, formatError } from "@/lib/api";

const STATUS = ["new", "contacted", "closed"];
const COLOR = { new: "bg-aqua-soft text-aqua", contacted: "bg-blue-50 text-blue-700", closed: "bg-elevated text-ink-2" };

export default function AdminEnquiries() {
  const [filter, setFilter] = useState("all");
  const [items, setItems] = useState(null);
  const load = () => api.get(`/admin/enquiries${filter === "all" ? "" : `?status=${filter}`}`).then((r) => setItems(r.data));
  useEffect(() => { load(); }, [filter]); // eslint-disable-line react-hooks/exhaustive-deps
  const setStatus = async (id, status) => {
    try { await api.patch(`/admin/enquiries/${id}`, { status }); toast.success(`Marked ${status}`); load(); } catch (e) { toast.error(formatError(e)); }
  };
  return (
    <div>
      <div className="mb-4 flex items-center gap-3">
        <Select value={filter} onValueChange={setFilter}>
          <SelectTrigger data-testid="enq-filter-status" className="w-40 capitalize"><SelectValue /></SelectTrigger>
          <SelectContent>{["all", ...STATUS].map((s) => <SelectItem key={s} value={s} className="capitalize">{s}</SelectItem>)}</SelectContent>
        </Select>
        <p className="text-sm text-ink-3">Each enquiry is also emailed to the admin inbox.</p>
      </div>
      {!items ? <Loading /> : items.length === 0 ? <EmptyState testId="enq-empty" title="No enquiries yet" text="Course enquiries sent by learners will appear here." /> : (
        <div data-testid="enq-list" className="flex flex-col gap-3">
          {items.map((e) => (
            <div key={e.id} data-testid={`enq-item-${e.id}`} className="rounded-xl border border-line bg-surface p-5">
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <p className="font-semibold text-ink">{e.course_title}</p>
                  <p className="text-sm text-ink-2">{e.name} · <a href={`mailto:${e.email}`} className="text-aqua hover:underline">{e.email}</a>{e.phone && ` · ${e.phone}`}</p>
                  <p className="text-xs text-ink-3">{new Date(e.created_at).toLocaleString()} · admin email {e.email_status}{e.confirmation_status && ` · learner confirmation ${e.confirmation_status}`}</p>
                </div>
                <div className="flex items-center gap-2">
                  <span className={`rounded-full px-2.5 py-0.5 text-xs font-medium capitalize ${COLOR[e.status]}`}>{e.status}</span>
                  <Select value={e.status} onValueChange={(v) => setStatus(e.id, v)}>
                    <SelectTrigger data-testid={`enq-status-${e.id}`} className="h-8 w-32 capitalize"><SelectValue /></SelectTrigger>
                    <SelectContent>{STATUS.map((s) => <SelectItem key={s} value={s} className="capitalize">{s}</SelectItem>)}</SelectContent>
                  </Select>
                </div>
              </div>
              <p className="mt-3 whitespace-pre-wrap rounded-lg bg-canvas-2 p-3 text-sm text-ink-2">{e.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
